import config from "@/api-services/_config";

export default {
    deleteRoomConversation(roomId) {
        return fetch(`${config.url}/conversation:index/delete-room-conversation`, { method: "POST", body: config.makeFormData({ room_id: roomId }), }).then((res) => res.json());
    },
    editAIResponse(data) {
        return fetch(`${config.url}/conversation:index/edit-ai-response`, { method: "POST", body: config.makeFormData(data), }).then((res) => res.json());
    }
};